import React from 'react';

function renderStatusHistory(statusHistory, { title, lang }) {
  if (!statusHistory || !statusHistory.length) {
    return null;
  }

  return (
    <div className='status-history'>
      <div className='animated fadeIn'>
        <h3 className='title bold text-center'>
          {title}
        </h3>
        <ul className='box'>
          {statusHistory.map(({ date, statusText, iconUrl }, i) => {
            return (
              <li key={i}>
                {date ? <span className='timestamp'>{date}</span> : null}
                <span className='status'>
                  {iconUrl && <img src={iconUrl} className={`status-icon ${lang}`} alt='Status icon' />}
                  {statusText}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export {
  renderStatusHistory
};
